exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1eCUR{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border-bottom:3px solid #ffeb3b;padding:10px}._2O4va{text-align:center;font-size:18px;font-weight:700;line-height:24px;margin:0;color:#000}", ""]);

// exports
exports.locals = {
	"titleContainer": "_1eCUR",
	"title": "_2O4va"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/LeasingOnlineBanner/Title/Title.css
// module id = 1556
// module chunks = 15 18 19 20 21 23 32 33 36 37 38